import styled from "styled-components";

export const TabsSectionWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TabsSectionContainer = styled.div`
  width: 100%;
  height: 100%;
`;
